import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import base from '../../base.styl';
import styles from './TopTitle.styl';

const TopTitle = props => {
  return (
    <div className={styles.titleWrapper}>
      <h1 className={styles.headline}>Protect the <span className={styles.highlighted}>Endangered Species Act</span></h1>
    </div>
  );
};

export default TopTitle;



// WEBPACK FOOTER //
// ./src/components/static/TopTitle.js